import axios from "axios";

// Action for searching a particular stock
export const getQueriedStocks = data => async dispatch => {
    try {
        const headers = {
            'x-rapidapi-host': 'bb-finance.p.rapidapi.com',
            'x-rapidapi-key': '35f0e8c68dmshcc1768d061f1c3dp1cbd3bjsne3777f68063f'
        }
        const options = {
            headers: headers,
            params: {query: data.query},
        }
        const response = await axios.get("https://bb-finance.p.rapidapi.com/market/auto-complete", options);
        return response;
    } catch (error) {
        console.log(error);
        return error.response;
    }
}


export const optimizePortfolio = data => async dispatch => {
    try {
        const response = await axios.post("/api/stock/optimize-portfolio", data);
        return response;
    } catch (error) {
        console.log(error);
        return error;
    }
}

